import { ref } from 'vue';

const globalSuccess = ref<string | null>(null);

export function useGlobalSuccess() {
  const setSuccess = (message: string) => {
    globalSuccess.value = message;
  };

  const clearSuccess = () => {
    globalSuccess.value = null;
  };

  return {
    globalSuccess,
    setSuccess,
    clearSuccess,
  };
}
